import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var market = process.env.APP.market_iso

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: require('@/views/Home').default,
      meta: { requiresAuth: false }
    },
    {
      path: '/shops',
      name: 'shops',
      component: require('@/views/Shops').default,
      meta: { requiresAuth: false }
    },
    {
      path: '/resetpassword/token/:token',
      name: 'resetPassword',
      component: require('@/views/PasswordReset').default,
      meta: { requiresAuth: false }
    },
    {
      path: '/verifymail/token/:token',
      name: 'verifyAccount',
      component: require('@/views/VerifyAccount').default,
      meta: { requiresAuth: false }
    },
    {
      path: '/profile',
      name: 'profile',
      component: require('@/views/UserProfile').default,
      meta: { requiresAuth: true }
    },
    {
      path: '/shop/:id',
      name: 'shop',
      component: require('@/views/Shop').default,
      meta: { requiresAuth: false }
    },
    {
      path: '/products',
      name: 'products',
      component: require('@/views/Products').default,
      meta: { requiresAuth: false }
    },
    {
      path: '/shop/:shop/products',
      name: 'shopProducts',
      component: require('@/views/ShopProducts').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/shops/category/:category',
      name: 'shopCategory',
      component: require('@/views/ShopCategory').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/videochat/:line',
      name: 'liveCall',
      component: require('@/views/VideoChat').default,
      meta: { requiresAuth: true }
    },
    {
      path: '/cart',
      name: 'cart',
      component: require('@/views/Cart').default,
      meta: { requiresAuth: true }
    },
    {
      path: '/checkout/:cart',
      name: 'checkout',
      component: require('@/views/Checkout').default,
      meta: { requiresAuth: true }
    },
    {
      path: '/order/:order',
      name: 'orderSummary',
      component: require('@/views/Order').default,
      meta: { requiresAuth: true }
    },
    {
      path: '/service/terms-and-conditions',
      name: 'service.Agb',
      component: require('@/views/service/Agb-' + market).default,
      meta: { requiresAuth: false }
    },
    {
      path: '/service/privacy',
      name: 'service.Privacy',
      component: require('@/views/service/Privacy').default,
      meta: { requiresAuth: false }
    },
    {
      path: '/service/delivery',
      name: 'service.Delivery',
      component: require('@/views/service/Delivery').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/service/imprint',
      name: 'service.Imprint',
      component: require('@/views/service/Imprint').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/service/contact',
      name: 'service.Contact',
      component: require('@/views/service/Contact').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/service/press',
      name: 'service.Press',
      component: require('@/views/service/Press').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/service/payment',
      name: 'service.Payment',
      component: require('@/views/service/Payment').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/service/partner',
      name: 'service.Partner',
      component: require('@/views/service/Partner').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/service/terms-and-conditions-partners',
      name: 'service.AgbPartner',
      component: require('@/views/service/AgbPartner').default,
      meta: {requiresAuth: false}
    },
    {
      path: '/service/about',
      name: 'service.About',
      component: require('@/views/service/About').default,
      meta: {requiresAuth: false}
    },
    {
      path: '*',
      redirect: '/',
      meta: { requiresAuth: false }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js